"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PaginationTable_1 = require("../PaginationTable");
var react_1 = require("react");
require("../../styles/CustomerListPage.css");
require("../../styles/UserPage.css");
require("../../styles/AuditLogsPage.css");
var msal_react_1 = require("@azure/msal-react");
var msal_browser_1 = require("@azure/msal-browser");
var authConfig_1 = require("../../authConfig");
var customer_1 = require("../../api/customer");
var react_moment_1 = require("react-moment");
var XLSX = require("xlsx");
var reactstrap_1 = require("reactstrap");
//var FileSaver = require('file-saver');
var AuditLogPage = function (props) {
    var authRequest = __assign({}, authConfig_1.loginRequest);
    var inProgress = msal_react_1.useMsal().inProgress;
    var _a = react_1.useState(new Array()), list = _a[0], setList = _a[1];
    var _b = react_1.useState(props.companyId), companyId = _b[0], setCompanyId = _b[1];
    var auditLogColumns = [
        {
            Header: 'Date',
            accessor: 'createdAt',
            Cell: function (row) { return (React.createElement(React.Fragment, null,
                React.createElement(react_moment_1.default, { format: "DD MMM YYYY HH:mm A" }, row.value))); }
        },
        {
            Header: 'Email',
            accessor: 'email'
        },
        {
            Header: 'Action',
            accessor: 'action'
        }
    ];
    // for Export button (configurations)
    var fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    var fileExtension = '.xlsx';
    var exportToCSV = function (csvData, fileName) {
        var ws = XLSX.utils.json_to_sheet(csvData);
        var wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        var excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        var data = new Blob([excelBuffer], { type: fileType });
        //FileSaver.saveAs(data, fileName + fileExtension);
    };
    // for Export button
    var ExportButton = function () {
        exportToCSV(list, "Audit Log");
    };
    var onLoad = function () {
        //RequestProfileData();
        if (list.length === 0 && companyId > 0) {
            customer_1.getAuditLog(companyId).then(function (data) {
                console.log(data);
                setList(data);
            }).catch(console.error);
        }
    };
    react_1.useEffect(function () {
        if (list.length === 0 && inProgress === msal_browser_1.InteractionStatus.None)
            onLoad();
    }, [inProgress, list, setList, companyId, setCompanyId]);
    return (React.createElement(React.Fragment, null,
        React.createElement(msal_react_1.MsalAuthenticationTemplate, { interactionType: msal_browser_1.InteractionType.Redirect, authenticationRequest: authRequest },
            React.createElement("div", { className: "card-header AuditLogHeader" },
                React.createElement("div", { className: "AuditLogButton" },
                    React.createElement(reactstrap_1.Button, { color: "secondary", onClick: ExportButton },
                        React.createElement("img", { src: "./images/ExportIcon.svg" }),
                        ' ',
                        "Export Audit Logs"))),
            React.createElement("div", { className: "tableContainer auditLogsTable" }, list ? React.createElement(PaginationTable_1.PaginationTable, { columns: auditLogColumns, data: list }) : React.createElement(React.Fragment, null, "Loading...")))));
};
exports.default = AuditLogPage;
//# sourceMappingURL=AuditLogPage.js.map